<template>
  <div id="container">
    <div
      v-show="!showProvince"
      id="main"
      style="height: 600px; width: 100%"
    ></div>
    <div class="tool-tip" v-if="!showProvince">
      <!-- <dv-border-box-7> -->
      <div class="name">{{ proviceName }}</div>
      <div class="row row-m">
        <span>端口数:</span>&nbsp;&nbsp;{{ portNum }}个
      </div>
      <div class="row row-m">
        <span>营业额:</span>&nbsp;&nbsp;{{ turnoverMoney }}元
      </div>
      <div class="row">
        <span>用电量:</span>&nbsp;&nbsp;{{ electricityTotal }}度
      </div>
      <!-- </dv-border-box-7> -->
    </div>
    <provinceVue
      ref="province"
      v-if="showProvince"
      :provinceInfo="provinceInfo"
      :heatData="heatData"
      :type="type"
      :code="code"
      @backChina="backChina"
    ></provinceVue>
  </div>
</template>


<script>
import provinceVue from "./province.vue";
const chinaJson = require("../../utils/china.json");
export default {
  components: {
    provinceVue,
  },
  props: ["level", "regionId", "deviceType", "chooseproviceName"],
  data() {
    return {
      myChart: null,
      cdata: [],
      mapdataList: [],
      proviceName: "",
      portNum: "",
      turnoverMoney: "",
      electricityTotal: "",
      provinceInfo: {},
      heatData: [],
      code: "",
      type: "",
      showProvince: false,
      dataList: [
        { name: "南海诸岛" },
        { ename: "beijing", name: "北京", adcode: "110000" },
        { ename: "tianjin", name: "天津", adcode: "120000" },
        { ename: "shanghai", name: "上海", adcode: "310000" },
        { ename: "chongqing", name: "重庆", adcode: "500000" },
        { ename: "hebei", name: "河北", adcode: "130000" },
        { ename: "henan", name: "河南", adcode: "410000" },
        { ename: "yunnan", name: "云南", adcode: "530000" },
        { ename: "liaoning", name: "辽宁", adcode: "210000" },
        { ename: "heilongjiang", name: "黑龙江", adcode: "230000" },
        { ename: "hunan", name: "湖南", adcode: "430000" },
        { ename: "anhui", name: "安徽", adcode: "340000" },
        { ename: "shandong", name: "山东", adcode: "370000" },
        { ename: "xinjiang", name: "新疆", adcode: "650000" },
        { ename: "jiangsu", name: "江苏", adcode: "320000" },
        { ename: "zhejiang", name: "浙江", adcode: "330000" },
        { ename: "jiangxi", name: "江西", adcode: "360000" },
        { ename: "hubei", name: "湖北", adcode: "420000" },
        { ename: "guangxi", name: "广西", adcode: "450000" },
        { ename: "gansu", name: "甘肃", adcode: "620000" },
        { ename: "shanxi", name: "山西", adcode: "140000" },
        { ename: "neimenggu", name: "内蒙古", adcode: "150000" },
        { ename: "shanxi1", name: "陕西", adcode: "610000" },
        { ename: "jilin", name: "吉林", adcode: "220000" },
        { ename: "fujian", name: "福建", adcode: "350000" },
        { ename: "guizhou", name: "贵州", adcode: "520000" },
        { ename: "guangdong", name: "广东", adcode: "440000" },
        { ename: "qinghai", name: "青海", adcode: "630000" },
        { ename: "xizang", name: "西藏", adcode: "540000" },
        { ename: "sichuan", name: "四川", adcode: "510000" },
        { ename: "ningxia", name: "宁夏", adcode: "640000" },
        { ename: "hainan", name: "海南", adcode: "460000" },
        { ename: "taiwan", name: "台湾", adcode: "710000" },
        { ename: "xianggang", name: "香港", adcode: "810000" },
        { ename: "aomen", name: "澳门", adcode: "820000" },
      ],
      timerId: null, //定时器的标识
    };
  },
  destroyed() {
    clearInterval(this.timerId);
  },
  mounted() {
    this.initEchart();
    this.getData();
    // this.handleMapRandomSelect();
    // setTimeout(() => {
    //   this.initEchart();
    // }, 1000);
  },
  methods: {
    initEchart() {
      this.myChart = this.$echarts.init(document.getElementById("main"));
    },
    // 获取数据
    getData() {
      // debugger;
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/map"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: this.deviceType,
          regionId: this.regionId,
          level: this.level,
        }),
      }).then(({ data }) => {
        var timeData = [];
        if (data.code == 0) {
          // debugger
          this.cdata = data.data.provinceMapList;
          timeData = data.data.provinceMapList;
        }
        // 重组数据，每项增加ename
        for (var m = 0; m < this.cdata.length; m++) {
          for (var n = 0; n < this.dataList.length; n++) {
            if (timeData[m].name == this.dataList[n].name) {
              this.mapdataList.push({
                ename: this.dataList[n].ename,
                adcode: this.dataList[n].adcode,
                electricityTotal: timeData[m].electricityTotal,
                regionId: timeData[m].regionId,
                name: timeData[m].name,
                socketTotal: timeData[m].socketTotal,
                value: timeData[m].value,
              });
            }
          }
        }
        this.updateChart();
      });
    },
    getData2() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/map"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: "",
          regionId: "",
          level: 0,
        }),
      }).then(({ data }) => {
        var timeData = [];
        if (data.code == 0) {
          // debugger
          this.cdata = data.data.provinceMapList;
          timeData = data.data.provinceMapList;
        }
        // 重组数据，每项增加ename
        for (var m = 0; m < this.cdata.length; m++) {
          for (var n = 0; n < this.dataList.length; n++) {
            if (timeData[m].name == this.dataList[n].name) {
              this.mapdataList.push({
                ename: this.dataList[n].ename,
                adcode: this.dataList[n].adcode,
                electricityTotal: timeData[m].electricityTotal,
                regionId: timeData[m].regionId,
                name: timeData[m].name,
                socketTotal: timeData[m].socketTotal,
                value: timeData[m].value,
              });
            }
          }
        }
        this.updateChart();
      });
    },
    parentChoose() {
      // debugger;
      if (this.regionId && (this.regionId != null || this.regionId != "")) {
        this.showProvince = true;
        this.provinceInfo.name = this.chooseproviceName;
        this.getProviceEcharts(this.regionId);
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.province.initDate();
          });
        }, 500);
      }else{
        this.showProvince = false;
        this.getData2()
      }
    },
    getProviceEcharts(id) {
      this.heatData = [];
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getThermodynamicChart"),
        method: "get",
        params: this.$http.adornParams({
          findType: 0,
          regionId: id,
        }),
      }).then(({ data }) => {
        // console.log(data, "热力数据");
        if (data.code == 0) {
          // this.arry = data.data;
          for (var i = 1; i < data.data.length; i++) {
            //  根据data的长度进行循环
            // if (data.data[i].latitude != data.data[i - 1].latitude) {
            // }
            var latitude = data.data[i].latitude * 1;
            var longitude = data.data[i].longitude * 1;
            var value = data.data[i].chargingSocketCount;
            this.heatData.push([longitude, latitude, value]);
          }
        }
      });
    },
    updateChart() {
      const _this = this;
      _this.$echarts.registerMap("china", chinaJson);

      var chinaGeoCoordMap = {
        黑龙江: [127.9688, 45.368],
        内蒙古: [110.3467, 41.4899],
        吉林: [125.8154, 44.2584],
        北京市: [116.4551, 40.2539],
        辽宁: [123.1238, 42.1216],
        河北: [114.4995, 38.1006],
        天津: [117.4219, 39.4189],
        山西: [112.3352, 37.9413],
        陕西: [109.1162, 34.2004],
        甘肃: [103.5901, 36.3043],
        宁夏: [106.3586, 38.1775],
        青海: [101.4038, 36.8207],
        新疆: [87.9236, 43.5883],
        西藏: [91.11, 29.97],
        四川: [103.9526, 30.7617],
        重庆: [108.384366, 30.439702],
        山东: [117.1582, 36.8701],
        河南: [113.4668, 34.6234],
        江苏: [118.8062, 31.9208],
        安徽: [117.29, 32.0581],
        湖北: [114.3896, 30.6628],
        浙江: [119.5313, 29.8773],
        福建: [119.4543, 25.9222],
        江西: [116.0046, 28.6633],
        湖南: [113.0823, 28.2568],
        贵州: [106.6992, 26.7682],
        云南: [102.9199, 25.4663],
        广东: [113.12244, 23.009505],
        广西: [108.479, 23.1152],
        海南: [110.3893, 19.8516],
        上海: [121.4648, 31.2891],
        通用: [113.171646, 33.794614],
      };
      var convertData = function (lineDatas) {
        // lineDatas就是this.cdata
        var res = [];
        for (var i = 0; i < lineDatas.length; i++) {
          var dataItem = lineDatas[i];
          // 只有this.cdata的socketTotal!=0时，才将数据放入飞线
          if (dataItem.value != 0) {
            var fromCoord = chinaGeoCoordMap[dataItem.name];
          }
          var toCoord = [121.4648, 31.2891]; //中心点地理坐标
          if (fromCoord && toCoord) {
            res.push([
              {
                // 飞线从哪里出发
                coord: toCoord,
              },
              {
                // 飞线去往哪里
                coord: fromCoord,
                value: dataItem.value,
                lineStyle: {
                  color: "#ff0",
                },
              },
            ]);
          }
        }
        return res;
      };
      var pointData = function (chartDatas) {
        // chartDatas就是this.cdata
        var res1 = [];
        for (var i = 0; i < chartDatas.length; i++) {
          if (chartDatas[i].socketTotal != 0) {
            res1.push({
              value: chinaGeoCoordMap[chartDatas[i].name],
              itemStyle: { color: "#b9be23" },
            });
          }
        }
        return res1;
      };
      var option = {
        visualMap: {
          min: 0,
          max: 100000,
          right: "2%",
          bottom: 0,
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          // text: ["高", "低"], //取值范围的文字
          // inRange: {
          //   color: [ "#0953a9","#2a74bd","#4a95cf","#6cb6e2","#8ed9f6"], //取值范围的颜色
          // },
          // show: true, //图注
          pieces: [
            {
              gte: 100000,
              // lt: 999,
              label: ">=100000",
              color: "#64D3FE",
            },
            {
              gte: 50000,
              lt: 99999,
              label: "50000 - 99999",
              color: "#47ABF8",
            },
            {
              gte: 10000,
              lt: 49999,
              label: "10000 - 49999",
              color: "#2184F3",
            },
            {
              lt: 9999,
              label: "<10000",
              color: "#145EB4",
            },
          ],
        },
        geo: {
          map: "china", //引入地图数据
          roam: false, //不开启缩放和平移
          zoom: 1.2, //视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.5)",
            },
            emphasis: {
              //高亮的显示设置
              areaColor: "skyblue", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            // name: "china",
            name: "省份",
            type: "map",
            geoIndex: 0,
            data: _this.mapdataList,
          },
          {
            type: "lines",
            zlevel: 2,
            effect: {
              show: true,
              period: 4, //箭头指向速度，值越小速度越快
              trailLength: 0.1, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "arrow", //箭头图标
              symbolSize: 4, //图标大小
            },
            lineStyle: {
              normal: {
                color: "#fff", // 飞线颜色
                // width: 0.5, //尾迹线条宽度
                opacity: 0.1, //尾迹线条透明度
                curveness: 0.3, //尾迹线条曲直度
              },
            },
            visualMap: [
              {
                show: true,
                color: ["#ff3333", "orange", "yellow", "lime", "aqua"],
              },
            ],
            data: convertData(this.cdata),
          },
          //中心点
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            label: {
              normal: {
                show: true,
                position: "right",
                //offset:[5, 0],
                color: "#38ff85",
                formatter: (params) => {
                  // console.log(params, "paramsparamsparamsparamsparams");
                },
                textStyle: {
                  color: "#1DE9B6",
                },
              },
            },
            data: [],
          },
          //地图点的动画效果
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            data: pointData(this.cdata),
            symbolSize: 10,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "fill",
              period: 10,
              scale: 3,
            },
            hoverAnimation: true,
            zlevel: 1,
          },
        ],
      };
      this.myChart.setOption(option);
      this.myChart.on("click", function (params) {
        // debugger;
        console.log(params.data, "params.dataparams.dataparams.data");
        if (!params.data.ename) {
          alert("暂无" + params.name + "地图数据");
          return;
        }
        _this.showProvince = true;
        _this.provinceInfo.name = params.data.name;
        _this.getProviceEcharts(params.data.regionId);
        setTimeout(() => {
          _this.$nextTick(() => {
            _this.$refs.province.initDate();
          });
        }, 500);
        _this.$emit("fillChoose", {
          regionId: params.data.regionId,
          name: params.data.name,
          level:1
        });
      });
      var curIndx = -1;
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(function (e) {
        var dataLen = option.series[0].data.length;
        //高亮当前图形
        _this.myChart.dispatchAction({
          type: "mapUnSelect",
          seriesIndex: 0,
          dataIndex: curIndx,
        });
        curIndx = (curIndx + 1) % dataLen;
        // 高亮当前图形
        _this.myChart.dispatchAction({
          type: "mapSelect",
          seriesIndex: 0,
          dataIndex: curIndx,
        });
        // console.log(option.series[0].data[curIndx], "选中的22222"); //electricityTotal
        _this.proviceName = option.series[0].data[curIndx].name;
        _this.portNum = option.series[0].data[curIndx].socketTotal;
        _this.turnoverMoney = option.series[0].data[curIndx].value;
        _this.electricityTotal =
          option.series[0].data[curIndx].electricityTotal;
      }, 5000);
    },
    backChina() {
      this.showProvince = false;
      this.initEchart();
      this.getData2();
      // this.$cookie.set("regionId", "");
      this.$emit("clearChoose", { regionId: "" });
    },
  },
};
</script>
<style lang="scss" scoped>
#container {
  width: 100%;
  height: 587px;
  position: relative;
}
.tool-tip {
  position: absolute;
  left: 5%;
  bottom: 5%;
  .name {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #00ecfc;
    line-height: 20px;
    background: linear-gradient(360deg, #fff8c8 0%, #f7b500 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 10px;
  }
  .row {
    // padding: 0px 15px 15px 15px;
    font-size: 14px;
    color: #fff;
    span {
      color: #ffd012;
    }
  }
  .row-m {
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Map/china.vue